define('views/blocks/checkout/CheckoutDialogView',['jquery',
        'underscore',
        'backbone',
        'app',
        'SubView',
        'template!blocks/checkout/dialog-wrapper',
       ],
    function ($,
              _,
              Backbone,
              app,
              SubView,
              checkoutDialogWrapperTemplate
              ) {

        //
        // représente la modal de dialog qui s'ouvre en bas du checkout
        //

        return Backbone.View.extend(SubView).extend({

            className:function(){
                return 'checkout-opc__dialog '+this.name
            },
            tagName:'form',
            name:'default',

            initialize: function (options) {
                var view = this;
                view.subviews = [];
                view.render();
                app.trigger('openDialogCheckout',view);
                setTimeout(function(){
                    view.afterIntro();
                    view.$el.parent().on('click',$.proxy(view.wrapperClose,view));
                },1000);
            },
            afterIntro:function(){
            },
            getInner:function(){
                return '…';
            },
            getSubmitText:function(){
                return app.t('Valider','UI');
            },
            render:function(){
                var view = this;
                view.$el.html(checkoutDialogWrapperTemplate({
                    inner:view.getInner(),
                    name:view.name,
                    submitText:view.getSubmitText()
                }));
                view.$el.on('submit',view.submit,view);
                view.delegateEvents(_.defaults(view.events,{
                    'click .btn-submit':'submit',
                    'click .btn-close':'close',
                    'keydown':'keydown',
                }));
            },
            keydown:function(e){
                if(e.key === "Escape") {
                    e.stopPropagation();
                    e.preventDefault();
                    this.close(e);
                }
            },
            wrapperClose:function(e){
                if($(e.target).is('.modal-wrapper')){
                    this.close(e);
                }
            },
            close:function(e){
                this.trigger('close',this);
            },
            submit:function(e){
                return false;
            }

        });
    });
